var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0008 0.5C8.06261 0.500043 5.30024 1.64426 3.22266 3.72184L6.3571 8.75799L11.0008 11.5L12.6762 6.61652L11.0008 0.5Z",
    fill: "#FFF05A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5001C4.29688e-05 14.4383 1.14426 17.2007 3.22184 19.2783L7.21639 16.7447L11 11.5001L5.1978 10.689L0 11.5001Z",
    fill: "#FFF05A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7782 3.72192L13.869 6.86234L11 11.5001L16.7126 13.0059L22 11.5001C22 8.56188 20.8557 5.79951 18.7782 3.72192Z",
    fill: "#FBBE22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 22.5C13.9378 22.5 16.7002 21.3557 18.7778 19.2782L16.5015 14.6558L10.9996 11.5L9.375 18.4823L10.9996 22.5Z",
    fill: "#FBBE22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22184 3.72192C1.14426 5.79951 4.29688e-05 8.56184 0 11.5001H11L3.22184 3.72192Z",
    fill: "#FFD321"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22266 19.2782C5.30024 21.3557 8.06257 22.5 11.0008 22.5V11.5L3.22266 19.2782Z",
    fill: "#FFD321"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7782 3.72184C16.7006 1.64426 13.9382 0.500043 11 0.5V11.5L18.7782 3.72184Z",
    fill: "#FFD321"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7782 19.2782C20.8557 17.2006 22 14.4382 22 11.5H11L18.7782 19.2782Z",
    fill: "#FFD321"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54688 11.4999C3.54688 15.6167 6.88413 18.9539 11.0009 18.9539L12.9572 11.9845L11.0009 4.0459C6.88413 4.0459 3.54688 7.38315 3.54688 11.4999Z",
    fill: "#FBBE22"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4.0459V18.9539C15.1168 18.9539 18.454 15.6167 18.454 11.4999C18.454 7.38315 15.1168 4.0459 11 4.0459Z",
    fill: "#FF8B37"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0017 7.54126L9.45884 9.26396L7.34375 10.1989L8.50537 12.1985L8.74092 14.499L11.0017 14.0122L11.8764 11.5002L11.0017 7.54126Z",
    fill: "#FFF05A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4963 12.1985L14.6579 10.1989L12.5428 9.26392L11 7.54126V14.0121L13.2607 14.499L13.4963 12.1985Z",
    fill: "#FBBE22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.5,
    r: 10.5,
    fill: "none",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.bd94ab56d5edf7ab648b4a5d4a03b0e2.svg";
export { ForwardRef as ReactComponent };